// extracted by mini-css-extract-plugin
module.exports = {"section-calculation":"ErxBonusLandingPageHowBonusIsCalculated_section-calculation__O8qPC","rounded-table":"ErxBonusLandingPageHowBonusIsCalculated_rounded-table__XNJX7"};